import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import ProfilePageContainer, {
  profileUrl as getProfileUrl,
} from "components/ProfilePageLayout";
import ProfilePageDiscussions from "components/ProfilePageLayout/ProfilePageDiscussions";
import { profileDiscussionsUrl } from "components/ProfilePageLayout/ProfilePageDiscussions/ProfilePageDiscussionsList";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";

const ProfileDiscussionsPage: NextPageWithLayout = () => {
  return <ProfilePageDiscussions />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;

    const profileUrl = getProfileUrl(slug, true);

    const discussionsUrl = profileDiscussionsUrl(slug, 1, true);

    const [profile, discussions] = await Promise.all([
      baseFetcher(profileUrl, context),
      baseFetcher(discussionsUrl, context),
    ]);

    if (!profile || profile.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        profile,
        fallback: {
          [profileUrl]: profile,
          [`$inf$${discussionsUrl}`]: [discussions],
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps company discussions Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

ProfileDiscussionsPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <ProfilePageContainer {...pageProps}>{page}</ProfilePageContainer>
    </SWRConfig>
  );
};

export default ProfileDiscussionsPage;
